import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmall } = breakpoints;

const AuthLayout = styled.div`
  label: AuthLayout;

  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
  margin: 0 auto;

  @media (${widthSmall}) {
    max-width: 25rem;
  }
`;

export default AuthLayout;
